// @ts-nocheck
import '../advanced.scss';
import _ from 'lodash';
import { getGridFilters, getGridFiltersByColumn, getGridMetadata } from 'models/dynamicGrid/selector';
import { GRID_EVENTS } from 'molecules/ReactGrid/agGrid/constants';
import { Events } from 'molecules/ReactGrid/agGrid/utils/events';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getDispatch, getState } from 'reducers';
import { formatDate } from 'utils/utilities';
import { v4 as uuidv4 } from 'uuid';
import * as query from '../query';
import * as sagaActions from '../sagaActions';
import { FilterTags } from './filterTags';
import { AgGridSearchMultiSelectFilter } from './multiSelectFilter';



export const AgGridSearchFilter = props => {
	const { currentQuery, currentColumnRef, tableId, onUpdateQueries = () => null, isTagFilter = false, isInline } = props;
	const gridMetaData = useSelector(state => getGridMetadata(state, tableId));
	const selectedCriteria = query.getSearchParameters(currentColumnRef?.colDef?.metaData ?? {});
	const [isTagFilterOpen, setTagFilterOpen] = useState(false);

	const [filterOption, updateFilterOption] = useState(
		currentQuery?.operator || query.getCriteriaOperators(selectedCriteria ?? {})[0]
	);
	const [currentSearchInput, updateCurrentSearchInput] = useState(currentQuery?.query?.from || currentQuery?.query);
	const [currentSearchInputEnd, updateCurrentSearchInputEnd] = useState(currentQuery?.query?.to);

	useEffect(() => {
		updateCurrentSearchInput(currentQuery?.query?.from || currentQuery?.query);
		updateCurrentSearchInputEnd(currentQuery?.query?.to);
		updateFilterOption(currentQuery?.operator || query.getCriteriaOperators(selectedCriteria ?? {})[0]);
	}, [currentQuery?.query, currentQuery?.operator]);

	const [isSearchMultiSelect, setSearchMultiSelect] = useState(Boolean(gridMetaData?.MultiSelectOptions));


	if (!currentColumnRef) {
		return null;
	}
	const isTagEnabled = isTagFilter && isTagFilterOpen;
	if (isTagEnabled) {
        return (
			<FilterTags {...props} onToggleTagFilter={(value) => {
				setTagFilterOpen(value)
			}
			}  />
		);
	}
	return <AgGridSearchMultiSelectFilter {...props} onToggle={setSearchMultiSelect} isEnabled={isSearchMultiSelect} isInline={isInline} {...props}></AgGridSearchMultiSelectFilter>;

};

